"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChangeDecisionTimeout;
require("core-js/modules/es.function.name.js");
function ChangeDecisionTimeout(data) {
  this.name = 'BunnyPublisherTimeoutException';
  this.data = data;
  this.message = JSON.stringify(data);
  this.stack = new Error().stack;
}
ChangeDecisionTimeout.constructor = ChangeDecisionTimeout;